import React from 'react';
import {MetricsElement} from 'react-metrics';

import ProductImage from './product-image';
import Ratings from '@hpstellar/core/Ratings';
import KspList from './ksp-list';
import Link from '../../shared/components/hyperlink';
import Badge from './product-badge';
import ViolatorMessage from './product-violator';

import '../../product/css/product-card-detail.less';

const EMPTY_OBJECT = {};

const ProductCardDetail = props => {
    let { product, productUrl, displaySkuID = true, productIndex, hideMktDiff, productClickMetrics } = props;
    const { prdClass, attributes = EMPTY_OBJECT, categories=[], rating, numReviews } = product;
    let sku = product.sku && product.sku.replace(/^P_/i, '');

    let badgeText = '';

    if (prdClass === 'CTO') {
        badgeText = 'Customizable';
    } else if (
        attributes.carepacktype === 'electronic' ||
        /*category includes "software"*/ categories.includes('Zrz09') ||
        categories.includes('computer-software')
    ) {
        badgeText = 'Digital';
    }

    return (
        <div className="product-card-detail">
            <ProductImage
                link={productUrl}
                product={product}
                maxImgWidth={270}
                productIndex={productIndex}
                lazyLoad={false}
                className={'v2'}
                productClickMetrics={productClickMetrics}
            />
            <div className="reviews-row">
                <Ratings score={rating} reviewsCount={numReviews} />
                {badgeText && <Badge status="primary" text={badgeText} />}
            </div>
            <MetricsElement>
                <Link to={productUrl} className="product-title pdp-link" {...productClickMetrics || {}}>
                    <h3 aria-label={product.name}>{product.name}</h3>
                </Link>
            </MetricsElement>
            {product.prdClass === 'PRT' && props.pdp && (
                <div className="product-number">
                    <span>Product #: </span>
                    {sku}
                </div>
            )}
            {!hideMktDiff ? (
                <ViolatorMessage className="mkt-diff" product={product} clamp={1} className={'v2'} />
            ) : (
                <div className="violator-container empty"></div>
            )}
            <KspList ksps={product.ksps} className={'v2'} />
            {displaySkuID && <div className="product-sku">{sku}</div>}
        </div>
    );
};

export default ProductCardDetail;
